export function createCachedLookup<T extends object, K, V>(
  cache: WeakMap<T, Map<K, V>>,
  item: T | null | undefined,
  getValues: (t: T) => V[],
  keyExtractor: (v: V) => K,
): Map<K, V> {
  if (item === null || item === undefined) {
    return new Map();
  }

  let lookup = cache.get(item);
  if (!lookup) {
    lookup = createLookup(getValues(item), keyExtractor);
    cache.set(item, lookup);
  }

  return lookup;
}

function createLookup<K, V>(values: V[], keyExtractor: (v: V) => K): Map<K, V> {
  return new Map(values.map((data) => [keyExtractor(data), data]));
}
